import { LucideIconData } from 'lucide-angular';

export const PoolCaC53: LucideIconData = [
  ['circle', { cx: '12', cy: '12', r: '10' }],
  ['rect', { x: '7', y: '10', width: '10', height: '6', rx: '1' }],
  ['path', { d: 'M10 10 V7' }],
  ['path', { d: 'M14 10 V7' }],
];
